import api from "@/shared/api/api";
import type {
  GetReceivableSnapshotSummaryParams,
  PaginatedReceivableSnapshotSummaryResponse,
  ReceivableSnapshotCreator,
} from "../utils/types";
import { PaginatedResponse } from "@/features/profiles/services/profiles/types";

/**
 * API client responsável por listar os cálculos e a distribuição entre creators.
 */
export const receivableSnapshotApi = {
  listSummaries: (
    params?: GetReceivableSnapshotSummaryParams,
    signal?: AbortSignal,
  ): Promise<PaginatedReceivableSnapshotSummaryResponse> => {
    return api<PaginatedReceivableSnapshotSummaryResponse>({
      url: "/v1/receivable-creator-snapshots",
      method: "GET",
      params,
      signal,
    });
  },

  getDetail: async (paidDate: string, signal?: AbortSignal): Promise<ReceivableSnapshotCreator[]> => {
    const { data } = await api<PaginatedResponse<ReceivableSnapshotCreator>>({
      url: `/v1/receivable-creator-snapshots/${paidDate}?limit=9999999`,
      method: "GET",
      signal,
    });
    return data;
  },
};
